import {
    useEffect,
    useRef,
    type FC
} from "react";
import {
    Animated,
    Platform,
    View
} from "react-native";
import type IBubbleCaretProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useReducedMotion,
    MOTION_EASINGS
} from "../../../../helpers/motion";
import {
    useBubbleContext
} from "../../context";

const AnimatedView = Platform.OS === "web" ? View : Animated.View;

const BubbleCaret: FC<IBubbleCaretProps> = ({
    customTheme,
    color
}) => {
    const context = useBubbleContext();

    const {
        durations,
        borders,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const isReduced = useReducedMotion();

    const isWeb = Platform.OS === "web";

    const opacity = useRef(new Animated.Value(1)).current;

    const {
        container: containerDynamicStyle,
        webBlink: webBlinkDynamicStyle
    } = useStyles({
        lineHeight: context?.currentSize.lineHeight ?? 0,
        blinkDuration: durations.blink,
        borders,
        spaces,
        color
    });

    useEffect(() => {
        opacity.setValue(1);

        if(isReduced || isWeb) {
            return;
        }

        const animation = Animated.loop(Animated.sequence([
            Animated.timing(opacity, {
                duration: durations.blink / 2,
                easing: MOTION_EASINGS.inOut,
                useNativeDriver: false,
                isInteraction: false,
                toValue: 1
            }),
            Animated.timing(opacity, {
                duration: durations.blink / 2,
                easing: MOTION_EASINGS.inOut,
                useNativeDriver: false,
                isInteraction: false,
                toValue: 0
            })
        ]));

        animation.start();

        return () => {
            animation.stop();
        };
    }, [
        durations.blink,
        isReduced,
        opacity,
        isWeb
    ]);

    return <AnimatedView
        style={[
            stylesheet.container,
            containerDynamicStyle,
            isWeb ? !isReduced && [
                stylesheet.webBlink,
                webBlinkDynamicStyle
            ] : {
                opacity
            }
        ]}
        aria-hidden={true}
    />;
};
export default BubbleCaret;
